import cookies from 'js-cookie'

export const AUTH_COOKIE_NAME = 'EWS_AUTH_KEY'

// Persist the auth cookie for 30 days instead of writing a session cookie.
// A session cookie dies when the browser process exits, so quitting the
// browser (or rebooting) forced a full Okta round-trip every morning even
// though the stored Okta refresh token was still valid. The JWT inside is
// still short-lived and independently verified on every request — this only
// controls how long the browser holds onto it.
export const AUTH_COOKIE_DAYS = 30

export function authCookieDomain() {
  return `.${location.hostname.split('.').slice(-2).join('.')}`
}

/**
 * Write the shared auth cookie with a persistent expiry.
 *
 * @param {string} jwt
 * @param {object} [options] extra js-cookie options (e.g. sameSite for iframes)
 */
export function setAuthCookie(jwt, options = {}) {
  cookies.set(AUTH_COOKIE_NAME, jwt, {
    domain: authCookieDomain(),
    path: '/',
    expires: AUTH_COOKIE_DAYS,
    secure: true,
    ...options
  })
}

export function getAuthCookie() {
  return cookies.get(AUTH_COOKIE_NAME)
}

/**
 * Remove the shared auth cookie. Must match the domain/path used to set it,
 * otherwise the browser keeps the original cookie.
 */
export function removeAuthCookie() {
  cookies.remove(AUTH_COOKIE_NAME, { domain: authCookieDomain(), path: '/' })
}
